import moment from 'moment';
import { Constants } from './constants';

export const objectToQueryParams = (obj) => {
  const queryParams = [];

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent((Array.isArray(obj[key]) ? JSON.stringify(obj[key]) : obj[key]) || '');
      queryParams.push(`${encodedKey}=${encodedValue}`);
    }
  }

  return queryParams.join('&');
}

export const isNumber = (value) => value.match(/^\d*$/);

export const fromAssets = (url) => {
  return process.env.REACT_APP_BASE + url;
}

export const fromPhotos = (url) => {
  return process.env.REACT_APP_BASE_STORAGE + url;
}

export const clone = (data) => {
  return JSON.parse(JSON.stringify(data));
}

export const setMomentLocale = () => {
  moment.updateLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
    monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
    weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
    weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
    weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
  }
  );
}

export const createFormData = (data) => {
  var formdata = new FormData();
  for (var key in data) {
    if (Array.isArray(data[key])) {
      for (var _key in data[key]) {
        if (Array.isArray(data[key][_key])) {
          for (var i in data[key][_key]) {
            formdata.append(key + '[' + _key + '][' + i + ']', data[key][_key][i]);
          }
        }
        else {
          formdata.append(key + '[' + _key + ']', data[key][_key]);
        }
      }
    }
    else {
      formdata.append(key, data[key]);
    }
  }
  return formdata;
}

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
}

export const copy = (objectOrArray) => {
  return JSON.parse(JSON.stringify(objectOrArray));
}

export const getCountryFlagUrl = (countryId) => {
  switch (countryId) {
    case Constants.COUNTRIES.VEN:
      return 'img/venezuela.png';
    case Constants.COUNTRIES.COL:
      return 'img/colombia.png';
    default:
      return null;
  }
}

export const getCurrencySymbol = (countryId) => {
  switch (countryId) {
    case Constants.COUNTRIES.VEN:
      return Constants.CURRENCY_SYMBOLS.VEN;
    case Constants.COUNTRIES.COL:
      return Constants.CURRENCY_SYMBOLS.COL;
    default:
      return Constants.CURRENCY_SYMBOLS.USA;
  }
}

export const formatAmount = (amount, symbol, conversion = 1) => {
  if (isNaN(amount)) amount = 0;
  const formatted = Intl.NumberFormat('es-VE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(amount * conversion);
  return !!symbol ? `${symbol || ''} ${formatted}` : formatted;
}

export const autoFormatAmount = (amount, currency, conversion = 1) => {
  if (isNaN(amount)) amount = 0;
  conversion = currency?.is_local ? conversion : 1;
  const formatted = Intl.NumberFormat('es-VE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(amount * conversion);
  return !!currency?.symbol ? `${currency?.symbol || ''} ${formatted}` : formatted;
}

export const formatToApi = (amount) => {
  return Number(parseFloat(amount.replace(/\./g, '').replace(',', '.')).toFixed(2));
}

export const adjustAmount = (amount) => {
  if (typeof amount === 'string') {
    amount = amount.replace(/\./g, '').replace(',', '.');
  }

  const num = parseFloat(amount);
  if (isNaN(num)) return 0;

  const decimalPart = num.toString().split('.')[1] || '';

  return decimalPart.length <= 1 ? num * 100 : num;
};


export const getOnlyNumbers = (content) => {
  return content.match(/\d+/g)?.join('') || '';
}

export const formatNumericFields = (formData, numericFields) => {
  return Object.fromEntries(
    Object.entries(formData).map(([key, value]) => [
      key,
      numericFields.includes(key) ? Number(value) : value,
    ])
  );
};


// Para parsear los horarios para enviarlos al backend
export const transformScheduleToRender = (input) => {
  const output = [];


  // Iteramos sobre cada entrada en el arreglo
  input.forEach(item => {
    // Parseamos las horas eliminando los dos últimos caracteres ":00"
    const fromTime = item.from.slice(0, -3);
    const toTime = item.to.slice(0, -3);

    // Buscamos si ya existe una entrada con el mismo horario
    let existingEntry = output.find(entry => entry.from === fromTime && entry.to === toTime);

    // Si no existe, creamos una nueva entrada
    if (!existingEntry) {
      existingEntry = { from: fromTime, to: toTime, formatted_from_time: item.formatted_from_time, formatted_to_time: item.formatted_to_time };
      output.push(existingEntry);
    }

    // Asignamos el subject_id al día correspondiente
    existingEntry[item.day] = item.subject;
  });

  return output;
}


export const getStatusColor = (status) => {
  switch (status) {
    case Constants.USER.STATUS.ACTIVE:
      return 'text-green';
    case Constants.USER.STATUS.INACTIVE:
      return 'text-danger';
    case Constants.USER.STATUS.PENDING:
      return 'text-warning';
    default:
      return 'text-black';
  }
}

export const groupBy = (xs, key) => {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] ??= []).push(x);
    return rv;
  }, {});
};


export const findRouteName = (path, navItems) => {
  for (const item of navItems) {
    if (item.path === path) {
      return item.name;
    }
    if (item.submenu) {
      const found = findRouteName(path, item.submenu);
      if (found) return found;
    }
  }
  return '';
};

export const formatNumber = (value) => {
  value = value.replace(/\./g, ",");

  const regex = /^\d*(,\d{0,2})?$/;
  return regex.test(value) ? value : null;
};

export const parseTwoDecimals = (num) => {
  return Math.floor(num * 100) / 100;
}


export const groupBySubject = (questions) => {
  return Object.values(
    questions.reduce((acc, question) => {
      const { subject_id, subject_name, ...rest } = question;

      if (!acc[subject_id]) {
        acc[subject_id] = {
          subject_id,
          subject_name,
          questions: [],
        };
      }

      acc[subject_id].questions.push(rest);
      return acc;
    }, {})
  );
};

export const capitalizeFirstLetter = (word) => {
  if (!word || typeof word !== 'string') return '';
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const getUpdatedState = async (callback = () => {}) => {
  return await new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(null), 100);
    callback(s => {
      clearTimeout(timer);
      resolve(copy(s));
      return s;
    });
  });
}